import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllApprovals() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllApprovalRuleByUserId`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllSharedApprovals() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedApproval`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function checkConnection(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/checkConnectionForApprovalQueue/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateRulesforMine(payload, action, automationId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/removeUserFromAutomationRule/${automationId}/${action}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateRulesStatus(payload, action, automationId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateBusinessRuleForAutomationStatus/${automationId}/${action}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function SaveApprovalQueue(status, id, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/approvalProcessFunctionality/${status}/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function QueueDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getApprovalProcessMstDetaiPage/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteRequestId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteApprovalApprovalProcessRequest/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchAllOutReachQueueList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllOutreachQueueByApprovarId`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllApprovalMyList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCreatedOutreach`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllApprovalSharedList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedOutreach`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ruleDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByOutreachId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ruleSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createOutreach`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ruleUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateOutreach/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function OutreachLeadUpdate(payload, outReachId, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/addLeadToOutreach/${outReachId}/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function OutreachQueueUpdate(payload, outReachId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateOutreachQueue/${outReachId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteRuleId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteOutreach/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function checkcronjobqueue(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/checkOutreachLeadMail/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function checkLeadqueue(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/checkOutreachQueue/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchAllApprovals,
    ruleDetailData,
    ruleSave,
    ruleUpdate,
    deleteRuleId,
    FetchAllOutReachQueueList,
    FetchAllApprovalMyList,
    FetchAllApprovalSharedList,
    SaveApprovalQueue,
    FetchAllSharedApprovals,
    QueueDetails,
    deleteRequestId,
    updateRulesforMine,
    updateRulesStatus,
    checkConnection,
    OutreachLeadUpdate,
    OutreachQueueUpdate,
    checkLeadqueue,
    checkcronjobqueue,
}